module.exports = __webpack_public_path__ + "static/media/Bedroom7-2.d3d3743c.jpg";